// Search parameter keys for expenses page
export const EXPENSES_PAGE_SEARCH_KEYS = Object.freeze({
  SELECTED_EXPENSE_ID: 'selectedExpenseId',
  TAB: 'tab',
});

// Values of the `tab` search parameter: the detail panel tab to open
export const EXPENSES_PAGE_TAB_VALUES = Object.freeze({
  ACTIVITY: 'activity',
});
